module.exports = __webpack_public_path__ + "img/main-logo.4531ef90.png";